export default "/images/vendor/@coreui/icons/svg/flag/cif-ma.svg?0133a37692c38df07b1d3c9195011c60";